var map = {
	"./alisa@2x.png": 776,
	"./ameron@2x.png": 777,
	"./avida@2x.png": 778,
	"./bigbank@2x.png": 779,
	"./blank@2x.png": 780,
	"./bondora@2x.png": 781,
	"./brocc@2x.png": 782,
	"./businesscredit@2x.png": 783,
	"./capitalbox@2x.png": 784,
	"./capitalboxflex@2x.png": 785,
	"./cashbuddy@2x.png": 786,
	"./collectorbank@2x.png": 787,
	"./credento@2x.png": 788,
	"./credigo@2x.png": 789,
	"./credinord@2x.png": 790,
	"./euroloan@2x.png": 791,
	"./fellowfinance@2x.png": 792,
	"./fellowfinancebusiness@2x.png": 793,
	"./ferratum@2x.png": 794,
	"./ferratumbusinessflex@2x.png": 795,
	"./fundu@2x.png": 796,
	"./halino@2x.png": 797,
	"./instabank@2x.png": 798,
	"./kasvurahoitus@2x.png": 799,
	"./koincapital@2x.png": 800,
	"./komplettbank@2x.png": 801,
	"./laina.fi@2x.png": 802,
	"./lainaaja@2x.png": 803,
	"./lainaamo@2x.png": 804,
	"./leabank@2x.png": 805,
	"./luottorahoitus@2x.png": 806,
	"./mastercard@2x.png": 807,
	"./mylender@2x.png": 808,
	"./nordaxbank@2x.png": 809,
	"./norwegian@2x.png": 810,
	"./ostosraha@2x.png": 811,
	"./qred@2x.png": 812,
	"./resursbank@2x.png": 813,
	"./saldo@2x.png": 814,
	"./santander@2x.png": 815,
	"./surimo@2x.png": 816,
	"./svea@2x.png": 817,
	"./sveabusiness@2x.png": 818,
	"./tando@2x.png": 819,
	"./tuohi@2x.png": 820,
	"./vauraus@2x.png": 821,
	"./yritysluotto@2x.png": 822,
	"./yritysluottoflex@2x.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;